import api from '@motionelements/core/src/api/base-api-v2';

// eslint-disable-next-line
export const listArtistCategories = async (params) => {
  return api.get('/v2/artist/categories', {
    params: {
      ...api.getLocaleParams(),
      ...params,
    },
  });
};
